<template>
  <van-overlay :show="show" @click="cancel" :z-index="102">
    <div class="popup_box">
      <div class="popup">
        <div @click="cancel" class="popup_close close_center"><span></span></div>
        <div class="content">
          &nbsp;&nbsp;{{ $t('envelope.rule.r1') }} <br />&nbsp;&nbsp;{{ $t('envelope.rule.r2') }}
          <br />&nbsp;&nbsp;{{ $t('envelope.rule.r3') }} <br />&nbsp;&nbsp;{{
            $t('envelope.rule.r4')
          }}
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'
export default {
  name: 'LobbyActiveProgressPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
.popup_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .close_center {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    z-index: 2;
    margin-left: 85%;
    // margin-top: -5%;
    margin-bottom: -1rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }

  .popup {
    width: 5rem;
    height: auto;
    // padding: 0.3rem;

    background-color: #000;
    background-image: linear-gradient(#000, #000),
      linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    border-radius: 0.16rem;
    border: solid 0.04rem transparent;

    .content {
      width: 4.4rem;
      height: auto;
      padding: 0.3rem;
      font-family: DroidSans;
      font-weight: normal;
      font-size: 0.24rem;
      color: #ffddac;
      line-height: 0.3rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0.55rem;
    }
  }
}
</style>
